import React from 'react';

const PaxDispatch = React.createContext(null);

export default PaxDispatch;
